import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Currency } from '~/techstyle-shared/react-intl';

const PromoPriceStyled = styled(Currency)`
  color: ${({ theme }) => theme.colors.promoText};
  font-size: 18px;
  font-weight: 600;
`;

const PriceStyled = styled(Currency)`
  bottom: -18px;
  color: ${({ theme }) => theme.colors.promoPriceStrikethrough};
  font-size: 16px;
  font-weight: normal;
  position: absolute;
  right: 0;
  text-decoration: line-through;
`;

const PromoPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: right;
`;

export default function WearItWithPromoPrice({ discountPrice, regularPrice }) {
  return (
    <PromoPriceWrapper>
      {discountPrice ? (
        <PromoPriceStyled
          amount={discountPrice}
          data-autotag="product-promo-price"
        />
      ) : null}
      <PriceStyled
        showStrikethrough
        amount={regularPrice}
        data-autotag="product-retail-price"
      />
    </PromoPriceWrapper>
  );
}

WearItWithPromoPrice.propTypes = {
  discountPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  regularPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
